import React from "react";

const VerificationIcon = ({
  fill = "#387CFF",
  stroke = "#387CFF",
  ...props
}) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    <path
      d="M11.8862 3.2445L7.44321 1.341C7.30314 1.28096 7.15234 1.25 6.99996 1.25C6.84757 1.25 6.69677 1.28096 6.55671 1.341L2.11371 3.246C1.89186 3.34108 1.70647 3.50498 1.58492 3.7135C1.46337 3.92202 1.41211 4.16411 1.43871 4.404L1.92696 8.8005C2.06631 10.0519 2.68447 11.2009 3.65196 12.0068L6.27996 14.1968C6.4821 14.3651 6.73687 14.4573 6.99996 14.4573C7.26304 14.4573 7.51781 14.3651 7.71996 14.1968L10.3487 12.0068C11.3159 11.2008 11.9338 10.0518 12.073 8.8005L12.5612 4.404C12.588 4.16399 12.5368 3.92173 12.4152 3.71306C12.2937 3.50438 12.1082 3.33961 11.8862 3.2445Z"
      stroke={fill}
      strokeWidth="1.125"
      strokeLinecap="round"
    />
    <path
      d="M6.5708 7.66774C6.5708 7.54925 6.47474 7.45319 6.35625 7.45319V7.45319C6.23775 7.45319 6.14169 7.35713 6.14169 7.23863V6.80952C6.14169 6.45404 6.42987 6.16586 6.78535 6.16586H6.99991H7.21446C7.56995 6.16586 7.85812 6.45404 7.85812 6.80952V7.23863C7.85812 7.35713 7.76206 7.45319 7.64357 7.45319V7.45319C7.52508 7.45319 7.42902 7.54925 7.42902 7.66774V8.74051C7.42902 8.9775 7.2369 9.16962 6.99991 9.16962V9.16962C6.76292 9.16962 6.5708 8.9775 6.5708 8.74051V7.66774Z"
      fill={fill}
    />
  </svg>
);
export default VerificationIcon;
